import { useRouter } from 'next/router'
import styles from './DontSee.module.scss'
import {
  convertCategory,
  convertSize,
  convertPrice,
  convertGender,
  convertColor,
  convertHypoallergenic,
} from './lib/utils'

export default function DontSee({
  variables,
  breed,
  setNewRoute,
  areDogsThere,
  data,
  isMobile,
  setShowNotificationForm,
  isSubmitted,
}) {
  const router = useRouter()

  const extraKeys = ['frontendConfigData', 'page', 'breed', 'sort']
  const helpers = {
    category: convertCategory,
    size: convertSize,
    color: convertColor,
    price: convertPrice,
    convertGender,
    hypoallergenic: convertHypoallergenic,
  }

  const filters = Object.keys(variables)
    .filter(
      (v) =>
        !extraKeys.some((_k) => _k === v) &&
        !(v === 'price' && variables[v] === 11),
    )
    .map((k) => ({ key: k, value: helpers[k]?.(variables[k]) || variables[k] }))

  return (
    <div
      className={styles.container}
      style={
        areDogsThere && !isMobile
          ? {
              margin: '0 20px 20px',
            }
          : null
      }
    >
      {([3, 6, 9, 12].includes(data.length) && !isMobile) ||
        ([2, 4, 6, 8, 12].includes(data.length) && isMobile && (
          <div className={styles.notifyContainer}>
            {isSubmitted ? (
              <div className={styles.submitted}>
                <img src="/signin/bubble_icon.svg" alt="icon" />

                <div className={styles.text}>
                  <h3>Thank you!</h3>

                  <p>
                    We will notify you as soon as we have puppies matching your
                    preferences.
                  </p>
                </div>
              </div>
            ) : (
              <>
                <h3>
                  Get notified when {breed || 'more'} puppies become available.
                </h3>

                <button onClick={() => setShowNotificationForm(true)}>
                  <img src="/form_modal/alert.svg" alt="notification bell" />{' '}
                  Notify Me
                </button>
              </>
            )}
          </div>
        ))}

      {!areDogsThere && (
        <div className={styles.notifyContainer}>
          {isSubmitted ? (
            <div className={styles.submitted}>
              <img src="/signin/bubble_icon.svg" alt="icon" />

              <div className={styles.text}>
                <h3>Thank you!</h3>

                <p>
                  We will notify you as soon as we have puppies matching your
                  preferences.
                </p>
              </div>
            </div>
          ) : (
            <>
              <h3>
                Get notified when {breed || 'more'} puppies become available.
              </h3>

              <button onClick={() => setShowNotificationForm(true)}>
                <img src="/form_modal/alert.svg" alt="notification bell" />{' '}
                Notify Me
              </button>
            </>
          )}
        </div>
      )}

      <div
        className={styles.background}
        style={areDogsThere ? { marginTop: isMobile ? '10px' : '0px' } : null}
      >
        <h2>Don’t see what you’re looking for?</h2>

        <p>
          Try removing some filters to see more results or{' '}
          <span
            className={styles.clearAll}
            onClick={() => router.push('/search')}
          >
            Clear All.
          </span>
        </p>

        <div className={styles.filtersContainer}>
          {filters.map((f, i) => (
            <div
              key={i}
              className={styles.filter}
              style={f.key === 'color' ? { textTransform: 'capitalize' } : null}
            >
              <h4>{f.value}</h4>

              <div
                className={styles.clear}
                onClick={() =>
                  setNewRoute(f.key === 'breedSlug' ? 'breed' : f.key, null)
                }
              >
                <img src="/close-modal-grey.svg" alt="close icon" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
